import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export const useDebounce = ({ time = 1500, debouncedAction = null, debouncedFunction = null }) => {
    const [string, setString] = useState("");
    const [t, setT] = useState(null);
    const dispatch = useDispatch();

    const onChangeDebounce = (text) => {
        if (t) {
            clearTimeout(t);
        }
        const handleDebounce = () => {
            setString(text);
        };
        setT(setTimeout(handleDebounce, time));
    };

    useEffect(() => {
        if (!string) {
            return;
        }
        if (debouncedFunction) {
            debouncedFunction(string);
        }
        if (debouncedAction) {
            dispatch(debouncedAction(string));
        }
    }, [string]);

    return { onChangeDebounce };
};

export default useDebounce;
